import Symbol           from 'es6-symbol/polyfill';
import EventEmitter     from 'events';

let singleton = Symbol();
let singletonEnforcer = Symbol();

class ModalService extends EventEmitter {

  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this._datas = {};
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new ModalService(singletonEnforcer);
    }
    return this[singleton];
  }

  get datas() {
    return this._datas;
  }

  set datas(datas) {
    this._datas = datas;
  }

  open(datas) {
    return new Promise( (resolve, reject) => {
      this.datas = datas;
      this.resolve = resolve;
      this.reject = reject;
      this.emit('open');
    })
  }

  close() {
    this.emit('close');
  }

  cancel() {
    if(this.reject) {
      this.reject();
      this.reject = null;
    }
    this.emit('close');
  }

  confirm(datas = null) {
    if(this.resolve) {
      this.resolve(datas);
      this.resolve = null;
    }
    this.emit('close');
  }
}
export default ModalService.getInstance();